import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const Profile: React.FC = () => {
  return (
    <PageTemplate
      title="Profile"
      description="Manage your account settings and preferences"
    />
  );
};

export default Profile;